import {
  useOfflineRuntimeContext,
  type OfflineRuntimeContextValue,
} from '@/contexts/offlineRuntimeContext';

export const useOfflineRuntime = (): OfflineRuntimeContextValue => useOfflineRuntimeContext();
